import { makeVar } from '@apollo/client';

export type Answer = {
  id: string;
  sectionId: string;
  hasChecked?: boolean;
  answer?: string | number | boolean;
  correctAnswer: string | number | boolean;
  ignoreCase?: boolean;
  hasReset?: boolean;
  multiAnswer?: {
    answerRefs: string[];
    correctRefs: string[];
    correctLabels: string[];
  };
};

export type CheckAnswerData = {
  [key: string]: Answer | undefined;
};

export const checkAnswerVar = makeVar<CheckAnswerData>({});
